import brandService from '@services/brand';

import { ITEM_DROPDOWN_NONE_VALUE_FEMININE } from '@admin/utils/DropdownItems';

export const receiveBrandsOfClient = (brands) => ({
  type: 'CLIENT_BRANDS_SUCCESS',
  brands: [ITEM_DROPDOWN_NONE_VALUE_FEMININE(), ...brands],
});

export const requestBrandsOfClientError = () => ({
  type: 'CLIENT_BRANDS_FAILURE',
});

export const getBrandsOfClient = () =>
  function (dispatch) {
    dispatch({
      type: 'CLIENT_BRANDS_REQUEST',
    });
    return brandService.getBrandsOfClient();
  };
